import React, { useRef, useEffect } from 'react';

import I18n from '@module/i18n';

import { clickLegal } from '@module/consent-manager/tracker';

export function CcpaLegalText() {
  const element = useRef(null);
  const legalPageHref = '/legal/manage-cookies';

  useEffect(() => {
    const legalLinks = element.current.querySelectorAll(
      `a[href="${legalPageHref}"]`
    );
    if (legalLinks) {
      Array.from(legalLinks).forEach((legalLink) => {
        legalLink.onclick = clickLegal;
      });
    }
  }, [element]);

  const content = {
    text: {
      __html: I18n.t('transfer.consent-manager.ccpa-body', {
        href: legalPageHref,
      }),
    },
  };

  return (
    <div className="" ref={element}>
      <div
        className="ccpa-preferences__text"
        dangerouslySetInnerHTML={content.text}
      />
    </div>
  );
}
